import { getPartnerIdFromChatId } from "@/firebase/utils";
import { ActionTypes } from "@/store";
import { ButtonObject } from "@/types/button";
import { ChatSettingsScreenEnum } from "@/types/chat";
import { computed } from "vue";
import { ChatSettingsDetailsPropsObject } from "../ChatSettingsDetails";
import { useGetChatSettingsCommonProperties } from "../useGetChatSettingsCommonProperties";
import { reportUserWarningPoints } from "./reportUserWarningPoints";

export const useGetChatSettingsReportUserProperties = () => {
  const { authId, selectedChatId, route, router, dispatch } =
    useGetChatSettingsCommonProperties();

  const reportUserProperties = computed<ChatSettingsDetailsPropsObject>(() => {
    return {
      type: ChatSettingsScreenEnum.ReportUser,
      primaryButton: primaryButton.value,
      imageName: "reportUser.svg",
      warningPoints: reportUserWarningPoints,
    };
  });
  const primaryButton = computed<ButtonObject>(() => {
    return {
      handleClick: handlePrimaryButtonClick,
    };
  });

  const handlePrimaryButtonClick = async (): Promise<void> => {
    const chatId = selectedChatId.value ?? (route.params.chat_id as string);
    const partnerId = getPartnerIdFromChatId(authId.value, chatId);
    await dispatch(ActionTypes.REPORT_USER, partnerId);
    router.back();
  };

  return { reportUserProperties };
};
